import CollectionHero from './CollectionHero'

export default CollectionHero
